<div *ngIf="title !== IngredientType.noType && title" class="fields-title">
  <h3>{{ title }}</h3>
</div>
<div class="fields-container">
  <ng-content></ng-content>
</div>
